import { Grid } from '@mui/material';
import { WsTypography, WsTypoVariants } from 'wisestep-base';

import CountWithTextCard from '../../../analytics/components/countWithTextCard';
import usePotentialRevenueWidgetData from '../../DerivedCharts/PotentialRevenue/hooks/usePotentialRevenueWidgetData';
import { IPotentialRevenueDTO } from '../jobs/types/postgreJobsDTO';
import { IPotentialRevenueWidgetProp } from '../jobs/types/postgreJobsWidgetProp';

import {
  currencyNameSymbolMap,
  defaultPotentialRevenueWidgetData,
} from './utils/potentialRevenueHelper';

const PotentialRevenueMetricChart = ({ query, title }: IPotentialRevenueWidgetProp) => {
  const widgetData = usePotentialRevenueWidgetData<IPotentialRevenueDTO>(
    query,
    defaultPotentialRevenueWidgetData
  );

  return (
    <Grid container p={2}>
      <Grid item xs={12} mb={2}>
        <WsTypography variant={WsTypoVariants.TITLE} bold={true}>
          {title}
        </WsTypography>
      </Grid>
      {Object.keys(widgetData).map(
        (currency) =>
          currency &&
          widgetData[currency] != 0 &&
          widgetData[currency] != null && (
            <Grid key={currency} item xs={2} ml={10}>
              <CountWithTextCard
                variant="h3"
                count={`${currencyNameSymbolMap[currency] ?? ''}${Number(
                  widgetData[currency] ?? '0'
                ).toLocaleString()}`}
                fullHeight
                text={currencyNameSymbolMap[currency] ? '' : currency}
              />
            </Grid>
          )
      )}
    </Grid>
  );
};

export default PotentialRevenueMetricChart;
